export default "__VITE_ASSET__50f55f23__"